import { render, staticRenderFns } from "./ProjectCaseDetail.vue?vue&type=template&id=6ff6c90c&scoped=true"
import script from "./ProjectCaseDetail.vue?vue&type=script&lang=js"
export * from "./ProjectCaseDetail.vue?vue&type=script&lang=js"
import style0 from "./ProjectCaseDetail.vue?vue&type=style&index=0&id=6ff6c90c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff6c90c",
  null
  
)

export default component.exports